import React from 'react'
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Button,
  Box
} from '@mui/material'
import { useNavigate } from 'react-router'
import { authorUrl } from '../../helpers/url'

// Every card gets the same width, so the photos line up and the carousel's
// arrows move exactly one card. Phones (below md) use the narrower one.
export const AUTHOR_CARD_WIDTH = { mobile: 256, desktop: 282 }

const AuthorCard = ({ author, index, width }) => {
  const navigate = useNavigate()

  const handleAuthorClick = author => {
    navigate(authorUrl(author?.slug))
  }

  return (
    <Card
      onClick={() => handleAuthorClick(author)}
      data-test={`author-carousel-card-${index}`}
      sx={{
        width,
        flexShrink: 0,
        border: '1px solid #E0E0E0',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        p: 2,
        cursor: 'pointer',
        boxShadow: 'none'
      }}
    >
      {/* The photos arrive as squares already cropped around the face, so a
          square frame shows them whole. */}
      <Box
        sx={{
          width: '100%',
          aspectRatio: '1 / 1',
          borderRadius: ({ radius }) => `${radius.lg}px`,
          overflow: 'hidden'
        }}
      >
        <CardMedia
          component='img'
          image={author.image.imgUrl}
          alt={author.image.altText}
          data-test={`author-carousel-image-${index}`}
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'cover'
          }}
        />
      </Box>

      {/* The card's own padding frames the text too. The content stretches to
          the bottom so "See Author" lines up across cards whatever the
          length of the name and title. */}
      <CardContent
        sx={{
          flex: 1,
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          p: 0,
          pt: 2,
          '&:last-child': { pb: 0 }
        }}
      >
        <Typography variant='h6' component='div' fontWeight='bold' data-test={`author-carousel-name-${index}`}>
          {author.name}
        </Typography>
        <Typography variant='body2' color='text.secondary' mb={2} data-test={`author-carousel-title-${index}`}>
          {author.title}
        </Typography>
        <Button
          variant='outlined'
          size='small'
          data-test={`author-carousel-button-${index}`}
          sx={{
            mt: 'auto',
            borderRadius: 2,
            textTransform: 'none',
            borderColor: '#E0E0E0'
          }}
        >
          See Author
        </Button>
      </CardContent>
    </Card>
  )
}

export default AuthorCard
